import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    ExportExcelRight
} from '../../../business-components/Excel/Excel'

import {
    formataListExcel
} from '../../../business-components/Excel/ExcelService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosValor,
    formataTableCellBodyExibeDadosTitulo,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
    formataTableCellBodyExibeDadosPerc,
    formataTableCellBodyExibeDadosTotalTitulo,
    formataTableCellBodyExibeDadosTotalValor,
    formataTableCellBodyExibeDadosTotalPerc,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    tituloCliente,
} from '../cliente-form/ClienteService'

import {
    CardGridEstudoPadrao,
} from './EstudoComp'

import {
    aumentoLetraGarantias,
    ajusteAumentoLetraGarantiasDescricao,
    //ajusteAumentoLetraGarantiasValor,
} from './EstudoServiceGarantias'



const EstudoFormGarantiasRecursosFinanceirosDetalhado = ( { values, estudo, report, report1Pagina,
    indInicial, indFinal, popup, label, recursosFinanceirosDetalhado, detalhadoTipoRecurso } ) => {

    recursosFinanceirosDetalhado?.forEach( (item, ind) => {

        recursosFinanceirosDetalhado[ind].percAtivos =
            round(item.valor / estudo.current.ativos * 100, 2)
        recursosFinanceirosDetalhado[ind].percRecursosFinanceiros =
            round(item.valor / estudo.current.valorRecursosFinanceirosDetalhado * 100, 2)
    })

    const RecursosFinanceirosDetalhado = () => {

        const { aumentoLetraCabecalho, aumentoLetraReportCabecalho, aumentoLetra, aumentoLetraReport,
            aumentoLetraTotal, aumentoLetraTotalReport } = aumentoLetraGarantias(values, detalhadoTipoRecurso)

        let headList = [
            {
                colSpan: report ? 20 : 30,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.descricao, report, false,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values ),
            },
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.perc + ' ' + LABEL.ativos, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.perc + ' ' +
                    (detalhadoTipoRecurso ? LABEL.recursosFinanceirosAbreviado2 : LABEL.recursosFinanceiros), report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
        ]

        if (detalhadoTipoRecurso) {

            if (!report) {
           
                headList.push(
                    {
                        colSpan: 6,
                        headTitle: formataTableCellHeadExibeDadosValor(LABEL.dataInicioRecursoFinanceiro, report,
                            aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                )
            }

            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.percRentabilidadeMesAbreviado, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.percCDI, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.percRentabilidadeAnoAbreviado, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.percCDI, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
            )

            if (!report) {

                headList.push(
                    {
                        colSpan: 4,
                        headTitle: formataTableCellHeadExibeDadosValor(LABEL.percRentabilidade12MAbreviado, report,
                            aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                    {
                        colSpan: 4,
                        headTitle: formataTableCellHeadExibeDadosValor(LABEL.percCDI, report,
                            aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                    {
                        colSpan: 4,
                        headTitle: formataTableCellHeadExibeDadosValor(LABEL.percRentabilidade24MAbreviado, report,
                            aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                    {
                        colSpan: 4,
                        headTitle: formataTableCellHeadExibeDadosValor(LABEL.percCDI, report,
                            aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                )
            }

            headList.push(
                {
                    colSpan: 6,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.vencimento, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
            )
        }

        return (
            <>
                {(report1Pagina || popup) && ( // mudança da fonte
                    <h6>
                        {/*LABEL.recursosFinanceiros.toUpperCase()*/}
                        {label}
                    </h6>
                )}

                <TableExibeDados
                    report={report}
                    noMinW={true}
                >
                    <TableHeadExibeDados
                        report={report}
                        //popup={popup}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {recursosFinanceirosDetalhado?.map((item, ind) => {

                            let colSpan = 0

                            recursosFinanceirosDetalhado[ind].percAtivos =
                                round(item.valor / estudo.current.ativos * 100, 2)
                            recursosFinanceirosDetalhado[ind].percRecursosFinanceiros =
                                round(item.valor / estudo.current.valorRecursosFinanceirosDetalhado * 100, 2)

                            return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados
                                            ?
                                                formataTableCellBodyExibeDadosTitulo(item.descricao, report, false, false,
                                                    aumentoLetra + ajusteAumentoLetraGarantiasDescricao(values, item.descricao),
                                                        aumentoLetraReport +
                                                            ajusteAumentoLetraGarantiasDescricao(values, item.descricao), values)
                                            :
                                                formataTableCellBodyExibeDadosTotalTitulo(item.descricao, report,
                                                    aumentoLetraTotal, aumentoLetraTotalReport, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados
                                            ?
                                                formataTableCellBodyExibeDadosValor(item.valor, report, false, true,
                                                    aumentoLetra, aumentoLetraReport, values)
                                            :
                                                formataTableCellBodyExibeDadosTotalValor(item.valor, report, true,
                                                    aumentoLetraTotal, aumentoLetraTotalReport/* +
                                                        ajusteAumentoLetraGarantiasValor(values, item.valor)*/, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDadosTotal
                                            ?
                                                formataTableCellBodyExibeDadosTotalPerc(item.percAtivos, report, true,
                                                        aumentoLetraTotal, aumentoLetraTotalReport, values)
                                            :
                                                formataTableCellBodyExibeDadosPerc(item.percAtivos, report,
                                                        false, true, aumentoLetra, aumentoLetraReport, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDadosTotal
                                            ?
                                                formataTableCellBodyExibeDadosTotalPerc(item.percRecursosFinanceiros, report, true,
                                                        aumentoLetraTotal, aumentoLetraTotalReport, values)
                                            :
                                                formataTableCellBodyExibeDadosPerc(item.percRecursosFinanceiros, report,
                                                        false, true, aumentoLetra, aumentoLetraReport, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    {detalhadoTipoRecurso /*&& item.nivel === HARDCODE.reportNivelDados retirou em função da cor de fundo alternada das linhas*/ && (
                                        <>
                                            {!report && (
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[colSpan++].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosTexto(
                                                        item.dataInicioRecursoFinanceiro, report, false,
                                                            aumentoLetra, aumentoLetraReport, values)
                                                    }
                                                </TableCellBodyExibeDados>
                                            )}

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosPerc(
                                                    item.percRentabilidadeMesRecursoFinanceiro,
                                                        report, false, true, aumentoLetra, aumentoLetraReport, values)
                                                }
                                            </TableCellBodyExibeDados>

                                             <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosPerc(
                                                    item.percCDIMesRecursoFinanceiro,
                                                        report, false, true, aumentoLetra, aumentoLetraReport, values)
                                                }
                                            </TableCellBodyExibeDados>

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosPerc(
                                                    item.percRentabilidadeAnoRecursoFinanceiro,
                                                        report, false, true, aumentoLetra, aumentoLetraReport, values)
                                                }
                                            </TableCellBodyExibeDados>

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosPerc(
                                                    item.percCDIAnoRecursoFinanceiro,
                                                        report, false, true, aumentoLetra, aumentoLetraReport, values)
                                                }
                                            </TableCellBodyExibeDados>

                                            {!report && (
                                                <>
                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {formataTableCellBodyExibeDadosPerc(
                                                            item.percRentabilidade12MRecursoFinanceiro,
                                                                report, false, true, aumentoLetra, aumentoLetraReport, values)
                                                        }
                                                    </TableCellBodyExibeDados>

                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {formataTableCellBodyExibeDadosPerc(
                                                            item.percCDI12MRecursoFinanceiro,
                                                                report, false, true, aumentoLetra, aumentoLetraReport, values)
                                                        }
                                                    </TableCellBodyExibeDados>

                                                     <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {formataTableCellBodyExibeDadosPerc(
                                                            item.percRentabilidade24MRecursoFinanceiro,
                                                                report, false, true, aumentoLetra, aumentoLetraReport, values)
                                                        }
                                                    </TableCellBodyExibeDados>

                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {formataTableCellBodyExibeDadosPerc(
                                                            item.percCDI24MRecursoFinanceiro,
                                                                report, false, true, aumentoLetra, aumentoLetraReport, values)
                                                        }
                                                    </TableCellBodyExibeDados>
                                                </>
                                            )}

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosTexto(
                                                    item.vencimento, report, false,
                                                        aumentoLetra, aumentoLetraReport, values)
                                                }
                                            </TableCellBodyExibeDados>
                                        </>
                                    )}
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>  
            </>
        )
    }
    
    const camposExcel = ['descricao', 'valor', 'valor']
    
    if (detalhadoTipoRecurso) {

        camposExcel.push(
            'percAtivos',
            'percRecursosFinanceiros',
            'dataInicioRecursoFinanceiro',
            'percRentabilidadeMesRecursoFinanceiro',
            'percCDIMesRecursoFinanceiro',
            'percRentabilidadeAnoRecursoFinanceiro',
            'percCDIAnoRecursoFinanceiro',
            'percRentabilidade12MRecursoFinanceiro',
            'percCDI12MRecursoFinanceiro',
            'percRentabilidade24MRecursoFinanceiro',
            'percCDI24MRecursoFinanceiro',
            'vencimento',
        )
    } 

    return (
        report
            ?
                <GridContainer
                    //className='mt--2'
                >
                    <GridItem12>
                        <RecursosFinanceirosDetalhado/>
                    </GridItem12>
                </GridContainer>
            :
                <>
                    <ExportExcelRight
                        listExcel={formataListExcel(recursosFinanceirosDetalhado, camposExcel)}
                        nomeArquivoExcel={LABEL.recursosFinanceiros + ' ' + tituloCliente(values)}
                    />
            
                    <CardGridEstudoPadrao
                        label={label}
                        component={<RecursosFinanceirosDetalhado/>}
                        overflowX={true}
                        popup={popup}
                    />
                </>
    )
}

export default EstudoFormGarantiasRecursosFinanceirosDetalhado